import { render, staticRenderFns } from "./MangeGiftProgram.vue?vue&type=template&id=1de122d9&scoped=true"
import script from "./MangeGiftProgram.vue?vue&type=script&lang=js"
export * from "./MangeGiftProgram.vue?vue&type=script&lang=js"
import style0 from "./MangeGiftProgram.vue?vue&type=style&index=0&id=1de122d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de122d9",
  null
  
)

export default component.exports